"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBox = exports.WrapperStyled = exports.ItemStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _helpers = require("../../helpers");

var _carousel = require("../carousel/carousel.styled");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  ", ";\n\n  &:before {\n    height: ", "px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: -1;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  .slick-slider {\n    .slick-control {\n      top: 75px;\n      ", "\n\n      &:first-child {\n        left: -25px;\n      }\n\n      &:last-child {\n        right: -25px;\n      }\n    }\n\n    .slick-list {\n      padding: 5px 0;\n      margin-top: 25px;\n\n      .slick-track {\n        justify-content: center;\n\n        .slick-slide {\n          margin: 0 15px;\n        }\n\n        ", " {\n          .slick-slide {\n            width: ", "px !important;\n            margin: 0 10px;\n          }\n        }\n\n        ", " {\n          padding-left: 5px;\n        }\n      }\n      ", " {\n        margin-top: 10px;\n        overflow: visible;\n        margin-left: 10px;\n      }\n    }\n  }\n\n  ", " {\n    padding: 0 24px;\n  }\n\n  ", " {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 15px;\n  text-decoration: none;\n  cursor: pointer;\n  outline: none;\n  width: ", "px;\n\n  ", " {\n    width: ", "px;\n  }\n\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var mobileBlockSize = 87;
var desktopBlockSize = 109;
var ItemStyled = (0, _uiKit.styled)('a')(_templateObject(), desktopBlockSize, _uiKit.GridBreakpointsMediaDown.md, mobileBlockSize, _uiKit.TextStyled, _uiKit.Colors.wine);
exports.ItemStyled = ItemStyled;
var WrapperStyled = (0, _uiKit.styled)(_container.Container)(_templateObject2(), _carousel.CarouselDefaultArrowStyles, _uiKit.GridBreakpointsMediaDown.md, mobileBlockSize, _uiKit.GridBreakpointsMediaDown.xs, _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.sm, _carousel.CarouselItem);
exports.WrapperStyled = WrapperStyled;
var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject3(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
}, function (_ref2) {
  var $backDropHeight = _ref2.theme.$backDropHeight;
  return $backDropHeight || 0;
});
exports.StyledBox = StyledBox;